var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 1.66667C5.89984 1.66667 2.1665 5.40001 2.1665 10C2.1665 14.6 5.89984 18.3333 10.4998 18.3333C15.0998 18.3333 18.8332 14.6 18.8332 10C18.8332 5.40001 15.0998 1.66667 10.4998 1.66667ZM13.8582 10.4417L11.3582 12.9417C11.2332 13.0667 11.0748 13.125 10.9165 13.125C10.7582 13.125 10.5998 13.0667 10.4748 12.9417C10.2332 12.7 10.2332 12.3 10.4748 12.0583L11.9082 10.625H7.58317C7.2415 10.625 6.95817 10.3417 6.95817 10C6.95817 9.65834 7.2415 9.37501 7.58317 9.37501H11.9082L10.4748 7.94167C10.2332 7.70001 10.2332 7.30001 10.4748 7.05834C10.7165 6.81667 11.1165 6.81667 11.3582 7.05834L13.8582 9.55834C14.0998 9.80001 14.0998 10.2 13.8582 10.4417Z",
    fill: "#686C81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFilled);
export default __webpack_public_path__ + "static/media/arrow-right-filled.5107b59e0d5ee2c2a8e4ec02b5033202.svg";
export { ForwardRef as ReactComponent };